/**
 * Footer Component
 * 
 * Shared site footer with X/Twitter link, site URL, methodology, and data attribution
 * Design: Navy + Red brand lock (2026-09-16)
 */

import React from "react";
import { Link } from "react-router-dom";

const XIcon: React.FC<{ size?: number }> = ({ size = 14 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="currentColor"
    aria-hidden="true"
  >
    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
  </svg>
);

export const Footer: React.FC = () => {
  return (
    <footer className="site-footer">
      <div className="site-footer-content">
        <div className="site-footer-links">
          <a
            href="https://x.com/C_NFL_Impact"
            target="_blank"
            rel="noopener noreferrer"
            className="site-footer-link"
            aria-label="Follow @C_NFL_Impact on X"
          >
            <XIcon />
            <span>@C_NFL_Impact</span>
          </a>
          <span className="site-footer-separator">·</span>
          <a
            href="https://collegiatenflimpact.com"
            className="site-footer-link"
          >
            collegiatenflimpact.com
          </a>
          <span className="site-footer-separator">·</span>
          <Link to="/methodology" className="site-footer-link">
            Data &amp; Methodology
          </Link>
          <span className="site-footer-separator">·</span>
          <Link to="/about" className="site-footer-link">
            About
          </Link>
        </div>
        <p className="site-footer-credit">
          College and draft data supplemented by{" "}
          <a
            href="https://github.com/nflverse/nflverse-data"
            target="_blank"
            rel="noopener noreferrer"
          >
            nflverse
          </a>{" "}
          (
          <a
            href="https://creativecommons.org/licenses/by/4.0/"
            target="_blank"
            rel="noopener noreferrer"
          >
            CC BY 4.0
          </a>
          )
        </p>
      </div>
    </footer>
  );
};
